if (!customElements.get('offer-benefits')) {
  customElements.define(
    'offer-benefits',
    class OfferBenefits extends HTMLElement {
      constructor() {
        super();
        console.log('OfferBenefits component initialized');
        this.buyOnceBtn = this.querySelector('#buy-once');
        this.shippingText = this.querySelector('[data-shipping-text]');
        this.discountText = this.querySelector('[data-discount-text]');
        this.fallbackDiscountText = this.discountText ? this.discountText.textContent : '';
        this.buyOnceButton = this.querySelector('.offer-benefits__buy-once');
        this.upsellSelected = this.dataset.isUpsellSelected === 'true';
        this.ctaOneTimeUpsell = this.dataset.offerPriceUpsell || '';
        this.ctaOneTime = this.dataset.offerPrice || '';
        this.upsellDiscountText = this.discountText ? this.discountText.dataset.discountTextUpsell || '' : '';
        this.handleProductSelectedBound = this.handleProductSelected.bind(this);
        this.handleUpsellSelectedBound = this.handleUpsellSelected.bind(this);
        document.addEventListener('product-selected', this.handleProductSelectedBound);
        document.addEventListener('upsell-selected', this.handleUpsellSelectedBound);

        if (this.buyOnceBtn) {
          this.buyOnceBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.dispatchEvent(
              new CustomEvent('submit-one-time', {
                bubbles: true,
              }),
            );
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('product-selected', this.handleProductSelectedBound);
        document.removeEventListener('upsell-selected', this.handleUpsellSelectedBound);
      }

      handleProductSelected(event) {
        // Only handle events from multi-product-blocks within this section
        const eventSectionId = event.target.closest('offer-section')?.dataset.sectionId;
        console.log('Product selected event received in OfferBenefits:', event.detail, event.target, eventSectionId);
        if (eventSectionId === this.dataset.sectionId) {
          const { shippingFrequency, ctaOneTime, ctaOneTimeUpsell, benefitsDiscount, upsellProductId } = event.detail;

          if (shippingFrequency) {
            this.updateShippingText(shippingFrequency);
          }

          if (upsellProductId == '') {
            this.upsellSelected = false;
          }

          if (benefitsDiscount) {
            this.upsellDiscountText = benefitsDiscount; //this.upsellSelected ? this.fallbackDiscountText : benefitsDiscount;
          }
          this.updateBenefitsText();
          this.ctaOneTimeUpsell = ctaOneTimeUpsell;
          this.ctaOneTime = ctaOneTime;

          this.updateBuyOncePrice();
        }
      }

      handleUpsellSelected(event) {
        const eventSectionId = event.target.closest('offer-section')?.dataset.sectionId;
        if (eventSectionId === this.dataset.sectionId) {
          console.log('Upsell selected event received in OfferBenefits:', event.detail, event.target, eventSectionId);
          this.upsellSelected = event.detail.upsellSelected;
          this.updateBuyOncePrice();
          this.updateBenefitsText();
        }
      }

      updateBuyOncePrice() {
        if (this.buyOnceButton) {
          if (this.upsellSelected) {
            this.buyOnceButton.textContent = this.ctaOneTimeUpsell;
          } else {
            this.buyOnceButton.textContent = this.ctaOneTime;
          }
        }
      }

      updateShippingText(shippingFrequency) {
        if (this.shippingText) {
          this.shippingText.textContent = shippingFrequency;
        }
      }

      updateBenefitsText() {
        if (this.discountText) {
          if (this.upsellSelected) {
            this.discountText.textContent = this.fallbackDiscountText;
          } else {
            this.discountText.textContent = this.upsellDiscountText;
          }
        }
      }
    },
  );
}
